export const research = [
  {
    id: 1,
    title:
      'INDUSTRIAL AUTOMATION IN THE ERA OF INDUSTRY 4.0: INTEGRATING CYBER-PHYSICAL SYSTEMS, AI, AND IOT FOR SMART MANUFACTURING',
    type: 'Article',
    date: 'Oct 2025',
    author: 'Bakang Monei Motshegwe',
    description:
      'Industrial automation has transitioned from mechanized processes to intelligent, interconnected systems that underpin modern manufacturing competitiveness.',
    longDescription:
      'Industrial automation has transitioned from mechanized processes to intelligent, interconnected systems that underpin modern manufacturing competitiveness. With the emergence of Industry 4.0, automation has evolved through the convergence of cyber-physical systems (CPS), the Internet of Things (IoT), artificial intelligence (AI), and robotics, resulting in transformative capabilities that enhance productivity, quality, and operational efficiency.',
    fullTextAvailable: true,
    url: 'https://www.researchgate.net/publication/396271752_INDUSTRIAL_AUTOMATION_IN_THE_ERA_OF_INDUSTRY_40_INTEGRATING_CYBER-PHYSICAL_SYSTEMS_AI_AND_IOT_FOR_SMART_MANUFACTURING',
  },
  {
    id: 2,
    title:
      'A COMPARATIVE STUDY OF C++ AND RUST IN DEVELOPING HIGH-PERFORMANCE, LOW-LATENCY SYSTEMS',
    type: 'Article',
    date: 'Oct 2025',
    author: 'Bakang Monei Motshegwe',
    description:
      'High-performance systems such as financial trading platforms and real-time game engines require high concurrency, low latency, and guaranteed memory safety.',
    longDescription:
      'High-performance systems such as financial trading platforms and real-time game engines require high concurrency, low latency, and guaranteed memory safety. Traditionally, C++ has dominated this space due to its control over hardware and efficient runtime. However, Rust, a modern systems programming language, has emerged with a strong focus on memory safety without sacrificing performance, making it a compelling alternative for critical systems development.',
    fullTextAvailable: true,
    url: 'https://www.researchgate.net/publication/396272249_A_COMPARATIVE_STUDY_OF_C_AND_RUST_IN_DEVELOPING_HIGH-_PERFORMANCE_LOW-LATENCY_SYSTEMS',
  },
  {
    id: 3,
    title:
      'MOBILE APPLICATION DEVELOPMENT: A COMPARATIVE ANALYSIS OF NATIVE (KOTLIN/SWIFT) VERSUS CROSS-PLATFORM (FLUTTER/REACT NATIVE) FRAMEWORKS',
    type: 'Article',
    date: 'Oct 2025',
    author: 'Bakang Monei Motshegwe',
    description:
      'Mobile application development has evolved into one of the most competitive technological arenas.',
    longDescription:
      'Mobile application development has evolved into one of the most competitive technological arenas. As organizations strive for performance, scalability, and superior user experience, the debate between native development (Kotlin for Android and Swift for iOS) and cross-platform frameworks (Flutter, React Native) remains a critical decision point. This comparative analysis examines performance metrics, development efficiency, and platform-specific capabilities.',
    fullTextAvailable: true,
    url: 'https://www.researchgate.net/publication/396272356_MOBILE_APPLICATION_DEVELOPMENT_A_COMPARATIVE_ANALYSIS_OF_NATIVE_KOTLINSWIFT_VERSUS_CROSS-PLATFORM_FLUTTERREACT_NATIVE_FRAMEWORKS',
  },
  {
    id: 4,
    title:
      "HARNESSING ARTIFICIAL INTELLIGENCE FOR SUSTAINABLE BUSINESS TRANSFORMATION: ENHANCING RESILIENCE AND ECONOMIC INTEGRATION IN AFRICA'S 4IR LANDSCAPE",
    type: 'Conference Paper',
    date: 'Apr 2025',
    author: 'Bakang Monei Motshegwe',
    description:
      "This paper examines the transformative role of artificial intelligence (AI) in promoting sustainable business transformation and economic integration within Africa's Fourth Industrial Revolution (4IR) landscape.",
    longDescription:
      "This paper examines the transformative role of artificial intelligence (AI) in promoting sustainable business transformation and economic integration within Africa's Fourth Industrial Revolution (4IR) landscape. It highlights how AI-driven innovations are reshaping business strategies, enhancing operational efficiency, and strengthening resilience across various sectors. The research explores AI applications in finance, agriculture, healthcare, and infrastructure, demonstrating how intelligent systems can drive sustainable growth and economic integration across the continent.",
    fullTextAvailable: true,
    url: "https://www.researchgate.net/publication/391150439_HARNESSING_ARTIFICIAL_INTELLIGENCE_FOR_SUSTAINABLE_BUSINESS_TRANSFORMATION_ENHANCING_RESILIENCE_AND_ECONOMIC_INTEGRATION_IN_AFRICA'S_4IR_LANDSCAPE",
  },
  {
    id: 5,
    title:
      'REAL-TIME ENSEMBLE MACHINE LEARNING FOR EARLY DETECTION OF COMPULSIVE BETTING BEHAVIOR IN IGAMING PLATFORMS',
    type: 'Conference Paper',
    date: 'Mar 2025',
    author: 'Bakang Monei Motshegwe',
    description:
      'The rapid growth of online gambling platforms has amplified concerns regarding compulsive betting behaviors and their societal impacts.',
    longDescription:
      'The rapid growth of online gambling platforms has amplified concerns regarding compulsive betting behaviors and their societal impacts. This research proposes a novel real-time ensemble machine learning framework aimed at the early detection of problematic gambling behavior within iGaming environments. By integrating a combination of decision trees, neural networks, and support vector machines, the system achieves high accuracy in identifying at-risk users while maintaining low latency for real-time intervention.',
    fullTextAvailable: true,
    url: 'https://www.researchgate.net/publication/389682999_REAL-TIME_ENSEMBLE_MACHINE_LEARNING_FOR_EARLY_DETECTION_OF_COMPULSIVE_BETTING_BEHAVIOR_IN_IGAMING_PLATFORMS',
  },
  {
    id: 6,
    title:
      'AI-Powered Risk Assessment Models for Predicting Gambling Addiction: A Multi-Modal Approach',
    type: 'Conference Paper',
    date: 'Feb 2025',
    authors: ['Bakang Monei Motshegwe'],
    author: 'Bakang Monei Motshegwe',
    description:
      'Gambling addiction is a growing societal concern with profound psychological and financial consequences.',
    longDescription:
      'Gambling addiction is a growing societal concern with profound psychological and financial consequences. Existing risk assessment models primarily rely on self-reported data, limiting their accuracy in identifying early-stage addiction. This study proposes a novel AI-powered risk assessment framework that integrates Natural Language Processing (NLP), Computer Vision, and behavioral analytics to create a comprehensive multi-modal approach for predicting gambling addiction risk.',
    fullTextAvailable: true,
    url: 'https://www.researchgate.net/publication/388927799_AI-Powered_Risk_Assessment_Models_for_Predicting_Gambling_Addiction_A_Multi-Modal_Approach',
  },
];
